export const screenName = 'Forgot Password';
export const events = Object.freeze({
    sendNewPassword: 'Send New Password - Forgot Password Screen'
});

export const metrics = Object.freeze({
    screenName,
    events
});
